@import '../../constants/spacing.module.less';

.drawer-canvas {
  height: auto;
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.drawer-content {
  display: flex;
  flex-direction: column;
  padding: @space-24;
  flex: 1;
  min-height: 0;
  max-width: 1000px;
  margin: 0 auto;
  width: 100%;
}

.customer-info-section {
  margin-bottom: @space-24;
}

.previous-orders-section {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.orders-wrapper {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

.order-items-container {
  height: auto;
}

.drawer-footer {
  display: flex;
  justify-content: flex-end;
  padding: @space-16 @space-24;
  border-top: 1px solid var(--grey-200);
  background: var(--white);
}
